import React from "react";
import { Checkbox } from "@my-scoot/component-library-legacy";
import { IMultiCheckBoxInputTable } from "./MultiCheckBoxInputTable.interfaces";
import { MULTI_CHECKBOX_INPUT_TABLE_TYPES } from "./constants/MultiCheckBoxInputTable.constants";
import { useMultiCheckBoxInput } from "./utils/useMultiCheckBoxInput";

export function MultiCheckBoxInputTable<T extends Record<string, any>>({
  multiQuestions = [],
  rowKey,
  columns,
  onChange,
}: IMultiCheckBoxInputTable.IMultiTableInputProps<T>) {
  const { rows, handleCheckboxToggle, getAlignClass } = useMultiCheckBoxInput({
    multiQuestions,
    onChange,
  });

  return (
    <div className="tw-w-full tw-overflow-hidden tw-rounded-lg tw-border-solid tw-border tw-border-[#DADADA]">
      <table className="tw-w-full tw-border-collapse">
        <thead>
          <tr className="tw-bg-[#F6F6F6] tw-text-[#272522D9]">
            {columns.map((col) => (
              <th
                key={JSON.stringify(col)}
                className={`tw-py-3 tw-text-sm tw-font-medium ${getAlignClass(
                  col.align
                )}`}
              >
                {col.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((item, rowIndex) => (
            <tr
              key={String(item[rowKey])}
              className="tw-border-t tw-border-gray-200"
            >
              {columns.map((col) => (
                <td
                  key={JSON.stringify(col)}
                  className={`tw-py-[10px] ${getAlignClass(col.align)}`}
                >
                  {/* TEXT */}
                  {col.type === MULTI_CHECKBOX_INPUT_TABLE_TYPES.TEXT && (
                    <span className="tw-text-sm tw-line-clamp-none tw-leading-tight tw-text-gray-800">
                      {String(item[col.key])}
                    </span>
                  )}

                  {/* CHECKBOX */}
                  {col.type === MULTI_CHECKBOX_INPUT_TABLE_TYPES.CHECKBOX && (
                    <div className="tw-h-full tw-flex tw-flex-col tw-items-start tw-justify-center">
                      <Checkbox
                        size="large"
                        wrapperClassName="bg-white"
                        disabled={item?.disabled}
                        checked={item[col.key]}
                        color="#493AB1"
                        onChange={() => handleCheckboxToggle(rowIndex, col.key)}
                      />
                    </div>
                  )}

                  {/* CUSTOM */}
                  {col.type === MULTI_CHECKBOX_INPUT_TABLE_TYPES.CUSTOM &&
                    col.render(item)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
